var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      staticClass: "pb-6",
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "gg-card",
        {
          staticClass: "mb-6"
        },
        [
          _c("gg-card-header", [_vm._v(" Domain ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6",
                        lg: "4"
                      }
                    },
                    [_c("domain-select")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          staticClass: "mb-6 rounded-l",
          model: {
            value: _vm.subStep,
            callback: function callback($$v) {
              _vm.subStep = $$v
            },
            expression: "subStep"
          }
        },
        [
          _c(
            "v-stepper-header",
            [
              _vm._l(_vm.subSteps, function(stepItem) {
                return [
                  _c("v-stepper-step", {
                    key: "st-".concat(stepItem.value),
                    attrs: {
                      step: stepItem.value,
                      complete: _vm.subStep > stepItem.value
                    }
                  }),
                  stepItem.value < _vm.subSteps.length
                    ? _c("v-divider", {
                        key: "std-".concat(stepItem.value)
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          ),
          _c(
            "v-stepper-items",
            [
              _vm._l(_vm.subSteps, function(stepItem) {
                return _c(
                  "v-stepper-content",
                  {
                    key: "stc-".concat(stepItem.value),
                    staticClass: "pa-2",
                    attrs: {
                      step: stepItem.value
                    }
                  },
                  [
                    _c(stepItem.component, {
                      ref: stepItem.refName,
                      refInFor: true,
                      tag: "component"
                    })
                  ],
                  1
                )
              }),
              _c(
                "div",
                {
                  staticClass: "px-6 pb-5"
                },
                [
                  _c(
                    "gg-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.subStep > 1,
                          expression: "subStep > 1"
                        }
                      ],
                      staticClass: "mr-2",
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: function click($event) {
                          _vm.subStep--
                        }
                      }
                    },
                    [_vm._v("Back")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.subStep < _vm.subSteps.length,
                          expression: "subStep < subSteps.length"
                        }
                      ],
                      on: {
                        click: _vm.nextSubStep
                      }
                    },
                    [_vm._v("Next Step")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.subStep === _vm.subSteps.length,
                          expression: "subStep === subSteps.length"
                        }
                      ],
                      on: {
                        click: _vm.submit
                      }
                    },
                    [_vm._v("Create My website")]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: "",
                    tile: ""
                  },
                  on: {
                    click: function click($event) {
                      return _vm.setStep(1)
                    }
                  }
                },
                [_vm._v(" Back to Wizard Selection ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }